var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2133 16.5253C9.88807 16.8298 9.4533 17 9.00082 17C8.54835 17 8.11365 16.8298 7.78837 16.5253C4.80977 13.7195 0.81807 10.5852 2.7647 6.03475C3.81722 3.57437 6.34375 2 9.00082 2C11.6579 2 14.1845 3.57437 15.237 6.03475C17.1812 10.5795 13.1993 13.7292 10.2133 16.5253Z",
    fill: "#FF4444",
    stroke: "#FF4444",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 8.75C11.625 10.1997 10.4497 11.375 9 11.375C7.55025 11.375 6.375 10.1997 6.375 8.75C6.375 7.30025 7.55025 6.125 9 6.125C10.4497 6.125 11.625 7.30025 11.625 8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.5470ffd7669a132555a80cd52d650c1c.svg";
export { ForwardRef as ReactComponent };